import { useSelector } from '@xstate/react';

import type { MachineState } from '../../../../interfaces/machines';
import { isViewAvailable } from '../../helpers/view/isViewAvailable';
import type {
  Context as AuthenticationContext,
  Events as AuthenticationEvents,
} from '../../machine/types';

import { Context, Events } from './machine/types';
import { VIEWS } from './views/views';

interface SignUpProps {
  authenticationState: MachineState<AuthenticationContext, AuthenticationEvents>;
}

export const SignUp = ({ authenticationState }: SignUpProps) => {
  const { signUpService } = authenticationState.children;
  const currentState = useSelector(signUpService, state => state) as MachineState<Context, Events>;
  const stateName = currentState.value.toString();
  const { send } = signUpService;

  if (!isViewAvailable(stateName, VIEWS)) {
    throw new Error('There is no view for the given machine state.');
  }

  const CurrentView = VIEWS[stateName];

  return <CurrentView state={currentState} send={send} />;
};
